var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3198_9855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM11.6187 6.61875L7.61875 10.6187C7.44688 10.7906 7.225 10.875 7 10.875C6.775 10.875 6.55188 10.79 6.38094 10.6191L4.38094 8.61913C4.04 8.27725 4.04 7.72256 4.38094 7.38069C4.72281 7.03881 5.2775 7.03881 5.61938 7.38069L7 8.7625L10.3813 5.38125C10.7231 5.03937 11.2778 5.03937 11.6197 5.38125C11.9594 5.72187 11.9594 6.27813 11.6187 6.61875Z",
    fill: "#3FAE7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3198_9855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle-check.0d2ac43edd6deeccd44e9f5fb70d10e0.svg";
export { ForwardRef as ReactComponent };